"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "Content",
  componentId: "sc-uu9ltg-0"
})(["", ";padding-block:", " ", ";padding-inline:", ";color:", ";overflow-wrap:break-word;"], (0, _index.rootStyle)(), (0, _index.cssSpacing)('tighter-2', '8px'), (0, _index.cssSpacing)('looser-3', '48px'), (0, _index.cssSpacing)('looser-2', '32px'), (0, _index.cssColorValue)(_index.semanticColors.textBase));